/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 
import './fin-auth-playstore.js';
import './fin-auth-qr-code.js';
import './fin-auth-qr-success.js';
const template = html`
<custom-style>
        <style include="login-styles">
           
        </style>
</custom-style>
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
         <iron-pages selected="{{selectedLoginPage}}">
            <fin-auth-playstore selected-login-page="{{selectedLoginPage}}" selected-page={{selectedPage}} cronto-response={{crontoResponse}} from-playstore={{fromPlaystore}} selected-flag={{selectedFlag}}></fin-auth-playstore>
            <fin-auth-qr-code selected-login-page="{{selectedLoginPage}}" selected-page={{selectedPage}} cronto-response={{crontoResponse}} data-body={{dataBody}} selected-flag={{selectedFlag}} from-playstore={{fromPlaystore}} selected-flag={{selectedFlag}}></fin-auth-qr-code>
            <fin-auth-qr-success selected-login-page="{{selectedLoginPage}}" selected-page={{selectedPage}} from-qr-success={{fromQrSuccess}} ></fin-auth-qr-success>
         </iron-pages>`;
  
        Polymer({
            is: 'fin-auth-otp-landing',
            _template:template,
            properties: {
              selectedLoginPage:{
                  type:Number,
                  notify:true,
                  value:0
              },
              selectedPage: {
                  type: Number,
                  notify: true 
              },
              crontoResponse: {
                  type: Object,
                  notify: true
              },
              dataBody:{
                  type: Object,
                  notify: true
              },
              fromQrSuccess:{
                  type: Boolean,
                  notify: true 
              },
              fromPlaystore:{
                  type: Boolean,
                  notify: true 
              },
              selectedFlag: {
                  type: Boolean,
                  notify: true 
              }
            }
            
        }); 
